module.exports = __webpack_public_path__ + "static/src/content/images/processed/200/yes.9a052df.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/200/yes.jpg
// module id = wA+E
// module chunks = 0